import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock';
import { createElementFromHTML } from '../../js/helper';

class Overlay {
    constructor (options) {
        const defaults = {
            loader: null,
            speed: 125,
            contentClass: null,
            styleClass: null,
            overlayClass: null,
            overlayAriaLabel: null,
            overlayCloseAriaLabel: null,
            imageCornerShape: null,
            zoomImageID: null
        };

        this.settings = Object.assign({}, defaults, options);
        this.isVisible = false;

        if (this.settings.loader !== null) {
            this.$loader = createElementFromHTML(this.settings.loader);
        }

        this.initialize();
    }

    initialize () {
        const $body = document.querySelector('body');
        this.$overlay = document.createElement('div');
        this.$overlay.classList.add('overlay');
        this.$overlay.setAttribute('tabindex', '0');
        if (this.settings.overlayAriaLabel !== null) {
            this.$overlay.setAttribute('aria-label', this.settings.overlayAriaLabel);
        }

        if (this.settings.styleClass !== null) {
            this.$overlay.classList.add(this.settings.styleClass);
        }

        if (this.settings.overlayClass !== null) {
            this.$overlay.classList.add(this.settings.overlayClass);
        }

        this.$overlayContent = document.createElement('div');
        this.$overlayContent.classList.add('overlay__content');

        if (this.settings.contentClass !== null) {
            this.$overlayContent.classList.add(this.settings.contentClass);
        }

        if (this.settings.imageCornerShape !== null) {
            this.$overlayContent.classList.add(`has--${this.settings.imageCornerShape}`);
        }

        this.$overlayScroller = document.createElement('div');
        this.$overlayScroller.classList.add('overlay__scroller');

        this.$overlayClose = document.createElement('a');
        this.$overlayClose.classList.add('overlay__close');
        this.$overlayClose.classList.add('icon-close');
        this.$overlayClose.setAttribute('tabindex', '0');
        if (this.settings.overlayCloseAriaLabel !== null) {
            this.$overlayClose.setAttribute('aria-label', this.settings.overlayCloseAriaLabel);
        }

        this.$overlayScroller.appendChild(this.$overlayContent);

        this.$overlay.appendChild(this.$overlayScroller);
        this.$overlay.appendChild(this.$overlayClose);

        $body.appendChild(this.$overlay);

        this.setEvents();
    }

    setEvents () {
        this.$overlay.focus();

        const close = () => {
            this.destroy();
            if (this.settings.zoomImageID) {
                const imageItem = document.querySelector(`[data-zoom-image-id="${this.settings.zoomImageID}"]`);
                imageItem.focus();
                imageItem.removeAttribute('data-zoom-image-id');
            }
        };

        this.$overlayClose.addEventListener('click', () => {
            close();
        });

        this.$overlayClose.addEventListener('keydown', (event) => {
            if (event.code === 'Space' || event.code === 'Enter') {
                close();
            }
        });

        this.$overlay.addEventListener('keydown', (event) => {
            if (event.code === 'Escape') {
                close();
            }
        });

        this.$overlay.addEventListener('blur', (event) => {
            if (!this.$overlay.contains(event.relatedTarget)) {
                close();
            }
        }, true);

        if (!window.Modernizr.ie11 && window.Modernizr.csshover) {
            this.$overlay.addEventListener('click', (e) => {
                if (e.target.classList.contains('swiper-button-next') || e.target.classList.contains('swiper-button-prev')) {
                    e.preventDefault();
                } else {
                    if (!e.target.classList.contains('image__zoom') && !e.target.classList.contains('tabnav__item')) {
                        this.destroy();
                    }
                }
            });
        }
    }

    setContent ($content) {
        this.$overlayContent.innerHTML = '';
        this.$overlayContent.appendChild($content);
    }

    checkContent (callback) {
        const $singleImages = this.$overlayContent.querySelectorAll('[data-single-image="root"]');

        if ($singleImages.length > 0) {
            const $singleImageSliders = this.$overlayContent.querySelectorAll('[data-single-image-slider="slider"]');

            if ($singleImageSliders.length > 0) {
                import('../../modules/single-image/single-image').then(({ SingleImageSlider }) => {
                    for (let i = 0; i < $singleImageSliders.length; i++) {
                        const $singleImageSlider = new SingleImageSlider($singleImageSliders[i]);
                        $singleImageSlider.initialize();
                    }
                });
            }
        }

        if (typeof callback === 'function') {
            callback();
        }
    }

    show (callback) {
        this.$overlay.classList.add('is--visible');
        this.isVisible = true;

        disableBodyScroll(this.$overlayScroller);

        window.setTimeout(() => {
            if (typeof callback === 'function') {
                callback();
            }
        }, this.settings.speed);
    }

    hide (callback) {
        this.$overlay.classList.remove('is--visible');
        this.isVisible = true;

        enableBodyScroll(this.$overlayScroller);

        window.setTimeout(() => {
            if (typeof callback === 'function') {
                callback();
            }
        }, this.settings.speed);
    }

    destroy () {
        if (this.isVisible === false) {
            this.$overlay.parentNode.removeChild(this.$overlay);
        } else {
            this.hide(() => {
                const $overlayParent = this.$overlay.parentNode;
                if ($overlayParent) {
                    this.$overlay.parentNode.removeChild(this.$overlay);
                }
            });
        }
    }
}

export { Overlay };
